import {
  ADD_BORROWER,
  CHANGE_BORROWER_ID,
  REMOVE_BORROWER,
  SET_TITLE,
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_DOB,
  SET_BIRTH_SEX,
  SET_MIDDLE_NAME,
} from "./actions";

const reducer = (state, action) => {
  switch (action.type) {
    case SET_TITLE:
      return {
        ...state,
        borrowers: state.borrowers.map((borrower) => {
          if (borrower.id !== action.payload.id) {
            return borrower;
          }

          return {
            ...borrower,
            title: action.payload.value,
          };
        }),
      };

    case SET_FIRST_NAME:
      return {
        ...state,
        borrowers: state.borrowers.map((borrower) => {
          if (borrower.id !== action.payload.id) {
            return borrower;
          }

          return {
            ...borrower,
            firstName: action.payload.value,
          };
        }),
      };

    case SET_MIDDLE_NAME:
      return {
        ...state,
        borrowers: state.borrowers.map((borrower) => {
          if (borrower.id !== action.payload.id) {
            return borrower;
          }

          return {
            ...borrower,
            middleName: action.payload.value,
          };
        }),
      };

    case SET_LAST_NAME:
      return {
        ...state,
        borrowers: state.borrowers.map((borrower) => {
          if (borrower.id !== action.payload.id) {
            return borrower;
          }

          return {
            ...borrower,
            lastName: action.payload.value,
          };
        }),
      };

    case SET_DOB:
      return {
        ...state,
        borrowers: state.borrowers.map((borrower) => {
          if (borrower.id !== action.payload.id) {
            return borrower;
          }

          return {
            ...borrower,
            dob: action.payload.value,
          };
        }),
      };

    case SET_BIRTH_SEX:
      return {
        ...state,
        borrowers: state.borrowers.map((borrower) => {
          if (borrower.id !== action.payload.id) {
            return borrower;
          }

          return {
            ...borrower,
            birthSex: action.payload.value,
          };
        }),
      };

    case ADD_BORROWER:
      return {
        ...state,
        borrowers: [...state.borrowers, { id: action.payload }],
      };

    case REMOVE_BORROWER:
      return {
        ...state,
        borrowers: state.borrowers.filter(({ id }) => id !== action.payload),
      };

    case CHANGE_BORROWER_ID:
      return {
        ...state,
        borrowers: state.borrowers.map((borrower) => {
          if (borrower.id === action.payload.currentId) {
            return {
              ...borrower,
              id: action.payload.newId,
            };
          }

          return borrower;
        }),
      };

    default:
      return state;
  }
};

export default reducer;
